module.exports = __webpack_public_path__ + "img/02.1dec8c8f.jpg";